import { render, staticRenderFns } from "./CmgAccountModal.vue?vue&type=template&id=13980103&scoped=true&lang=pug&"
import script from "./cmg-account-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModal.vue?vue&type=style&index=0&id=13980103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13980103",
  null
  
)

export default component.exports